export const extractMessage = (obj) => {
  if (typeof obj === "string") return obj;
  if (typeof obj === "object" && obj !== null) {
    if (obj.error) return typeof obj.error === "string" ? obj.error : extractMessage(obj.error);
    if (obj.message) return typeof obj.message === "string" ? obj.message : extractMessage(obj.message);
    for (const key in obj) {
      const result = extractMessage(obj[key]);
      if (result) return result;
    }
  }
  return null;
}

export const getErrorBlob = async (err) => {
  try {
    const text = await err?.response?.data.text();
    let errorMsg = text;
    const json = JSON.parse(text);
    errorMsg = json?.message || JSON.stringify(json);
    return errorMsg;
  } catch (blobErr) {
    return 'Error desconocido al procesar PDF';
  }
}